import {accordions} from './init-accordion';

const wrapper = document.querySelector('.sub-form');

const onSubFormSubmit = (evt) => {
  if (!wrapper) {
    return;
  }

  evt.preventDefault();
  wrapper.classList.remove('sub-form--edit');
  const fields = wrapper.querySelectorAll('input, textarea');
  fields.forEach((field) => {
    field.readOnly = true;
    const fieldWrapper = field.closest('.custom-input, .custom-textarea');

    if (!fieldWrapper) {
      return;
    }

    fieldWrapper.classList.add('read-only');
    accordions.updateAccordionsHeight();
  });

  const periodSelect = wrapper.querySelector('select');
  const periodItem = wrapper.querySelector('.sub-form__sub-time-period');

  if (!periodSelect && !periodItem) {
    return;
  }

  const selectText = periodSelect.options[periodSelect.selectedIndex].text;
  periodItem.textContent = selectText;
};

const onEditBtnClick = (evt) => {
  evt.preventDefault();
  wrapper.classList.add('sub-form--edit');
  const fields = wrapper.querySelectorAll('input, textarea');
  fields.forEach((field) => {
    field.readOnly = false;
    const fieldWrapper = field.closest('.custom-input, .custom-textarea');

    if (!fieldWrapper) {
      return;
    }

    fieldWrapper.classList.remove('read-only');
    accordions.updateAccordionsHeight();

  });
};

const initSubForm = () => {
  if (!wrapper) {
    return;
  }

  const editBtn = wrapper.querySelector('.sub-form__edit-btn');

  editBtn.addEventListener('click', onEditBtnClick);
};

export {initSubForm, onSubFormSubmit};
